<template>
  <section class="feed">
    <transition name="feature" appear>
      <div class="feed__featured">
        <event-preview v-if="featuredEvent" :evt="featuredEvent" :featured="true"/>
      </div>
    </transition>

    <event-grid class="feed__grid" :events="events"/>

    <nav class="feed__nav">
      <router-link :to="prevPage || ''" tag="button" class="paging paging--prev" :data-disabled="!prevPage"/>
      <router-link :to="nextPage || ''" tag="button" class="paging" :data-disabled="!nextPage"/>
    </nav>
  </section>
</template>

<script>
import EventPreview from './EventPreview'
import EventGrid from './EventGrid'
import Api from 'src/api'

export default {
  name: 'event-calendar',
  components: { EventGrid, EventPreview },
  props: {
    paging: String
  },

  beforeMount() {
    if (this.paging) this.page = parseInt(this.paging)
    if (!this.feed) Api.dispatch.fetchAllEvents(this.featuredId)
  },

  data() {
    return {
      ready: false
    }
  },

  computed: {
    page() { return (!this.paging) ? 1 : parseInt(this.paging) },
    featuredEvent() { return this.$store.state.events.featured },
    featuredId() { return this.$store.state.content.calendar.featured },
    pages() { return (!this.feed) ? 0 : Math.ceil(this.feed.length / 4) },
    feed() {
      let events = this.$store.state.events.feed
      if (!events) return false
      return [...events.active, ...events.inactive.map(e => ({ ...e, inactive: true }))]
    },
    events() {
      let start = 4 * (this.page - 1)
      return (!this.feed) ? [] : this.feed.slice(start, start + 4)
    },
    nextPage() {
      if (this.page >= this.pages) return false
      return `/evenements/page/${this.page + 1}`
    },
    prevPage() {
      if (this.page === 1) return false
      return (this.page > 2) ? `/evenements/page/${this.page - 1}` : '/evenements'
    }
  },

  watch: {
    events(to) {
      if (!this.ready && to.length) this.ready = true

      setTimeout(() => {
        document.body.scrollTop = 0
      }, 400)
    }
  }
}
</script>

<style lang="scss">
@import '~sass/tools', '~sass/tools/mediaqueries';

.feature {
  &-enter-active,
  &-leave-active {
    transition: opacity 300ms cb(io), transform 250ms cb(io);
  }

  &-enter,
  &-leave-to {
    transform: translate3d(0,-5vh,0);
    opacity: 0;
  }

  &-enter-to,
  &-leave {
    transform: translate3d(0,0,0);
    opacity: 1;
  }
}

@media (--tablet) {
  .feature {
    &-enter-active,
    &-leave-active {
      transition: all 400ms cb(io);
    }

    &-enter,
    &-leave-to {
      transform: translate3d(0,-2.5%,0);
      opacity: 0;
    }

    &-enter-to,
    &-leave {
      transform: translate3d(0,0,0);
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// EventCalendar.vue?4162ddbb